import { Button } from '@/components/button/button';
import Download from '@/assets/icons/file-05.svg?react';
import { Tooltip } from 'antd/lib';

interface ExportButtonProps {
  isExporting: boolean;
  onPrepareExport: () => void;
  isMobile: boolean;
  isEmptyData: boolean;
  isDisabled?: boolean;
}

export function ExportButton({
  isExporting,
  onPrepareExport,
  isMobile,
  isEmptyData,
  isDisabled,
}: ExportButtonProps) {
  return (
    <Tooltip title={isEmptyData ? 'There is no data to export for the selected period.' : ''}>
      <div>
        <Button
          loading={isExporting}
          disabled={isDisabled || isEmptyData}
          rightIcon
          onClick={onPrepareExport}
          icon={<Download style={{ width: 10, height: 10 }} />}
          style={{
            margin: 'auto',
            fontSize: 14,
            fontWeight: 400,
            padding: isMobile ? '0px 5px' : '0px 12px',
          }}
          buttonVariant="secondary"
        >
          Prepare Export
        </Button>
      </div>
    </Tooltip>
  );
}
